import { render, staticRenderFns } from "./BulkAdd.vue?vue&type=template&id=ee1cf310&"
import script from "./BulkAdd.vue?vue&type=script&lang=js&"
export * from "./BulkAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports